import React, {useState} from 'react';
import PropTypes from 'prop-types';
import ContactForm from './components/ContactForm';
import AppointmentLocationForm from './components/AppointmentLocationForm';
import AppointmentCalendarForm from './components/AppointmentCalendarForm';
import Validate from 'react-form-controlled-validate';
import {Screens} from './components/constants';
import AppointmentInformation from './components/AppointmentInformation';
import classnames from 'classnames';

function ContactMe (props) {
  const {
    guideType,
    guideDelivery,
    bookAppointment,
    onComplete,
    backButton,
    loadingIcon,
    useAppointmentFlow,
    isProcessing,

    contactLead,
    contactFormConfig,
    onContactFormSubmit,

    getLocations,
    setLocation,
    availableLocations,
    selectedLocation,
    onLocationSearchChange,
    locationSearchForm,

    getTimeSlots,
    setTimeSlot,
    availableTimeSlots,
    selectedTime
  } = props;

  const [currentScreen, changeScreen] = useState(Screens.CONTACT_FORM);

  let FrameComponent = null;
  let showBackBtn = false;
  let schema, fields;

  if (contactFormConfig) {
    fields = contactFormConfig.fields;
    schema = contactFormConfig.schema;
  } else {
    if (guideType === 'business') {
      schema = ContactForm.defaultBusinessSchema;
      fields = ContactForm.defaultBusinessFields;
    } else {
      schema = ContactForm.defaultConsumerSchema;
      fields = ContactForm.defaultConsumerFields;
    }
    if (guideDelivery === 'branch') {
      fields = fields.concat(['customerId']);
    }
  }

  const backBtnClicked = () => {
    let nextScreen = false;
    switch (currentScreen) {
      case Screens.APPT_CALENDAR:
        nextScreen = Screens.APPT_LOCATION;
        break;
      case Screens.APPT_LOCATION:
        nextScreen = Screens.CONTACT_FORM;
        break;
      case Screens.APPT_FAIL:
        nextScreen = Screens.CONTACT_FORM;
        break;
      default:
        break;
    }
    if (nextScreen) {
      changeScreen(nextScreen);
    }
  };

  const backButtonRender = <button className="contactMe__backBtn" onClick={backBtnClicked}>
    {backButton || <span>←</span>}
  </button>;

  const loadingIconRender = <div className="contactMe__loadingIcon" onClick={backBtnClicked}>
    {loadingIcon || <span className="spinning">◌</span>}
  </div>;

  const classes = classnames('contactMe', `contactMe--${currentScreen}`);

  switch (currentScreen) {
    case Screens.CONTACT_FORM:
      FrameComponent = <Validate schema={schema}>
        <ContactForm
          changeScreen={changeScreen}
          contactLead={contactLead}
          fields={fields}
          schema={schema}
          useAppointmentFlow={useAppointmentFlow}
          onContactFormSubmit={onContactFormSubmit}
          onComplete={onComplete}
          isProcessing={isProcessing}
        />
      </Validate>;
      break;
    case Screens.APPT_LOCATION:
      FrameComponent = <AppointmentLocationForm
        changeScreen={changeScreen}
        selectedLocation={selectedLocation}
        locationSearchForm={locationSearchForm}
        setLocation={setLocation}
        onLocationSearchChange={onLocationSearchChange}
        getLocations={getLocations}
        availableLocations={availableLocations}
        isProcessing={isProcessing}
      />;
      showBackBtn = true;
      break;
    case Screens.APPT_CALENDAR:
      FrameComponent = <AppointmentCalendarForm
        changeScreen={changeScreen}
        bookAppointment={bookAppointment}
        getTimeSlots={getTimeSlots}
        selectedLocation={selectedLocation}
        selectedTime={selectedTime}
        contactLead={contactLead}
        availableTimeSlots={availableTimeSlots}
        setTimeSlot={setTimeSlot}
        onComplete={onComplete}
        isProcessing={isProcessing}
      />;
      showBackBtn = true;
      break;
    case Screens.APPT_SUCCESS:
      FrameComponent = <AppointmentInformation
        selectedLocation={selectedLocation}
        selectedTime={selectedTime}
        success
      />;
      break;
    case Screens.APPT_FAIL:
      FrameComponent = <AppointmentInformation/>;
      break;
    default:
      break;
  }

  return <div className={classes}>
    {FrameComponent}
    {isProcessing ? loadingIconRender : null}
    {!isProcessing && showBackBtn ? backButtonRender : null}
  </div>;
}

ContactMe.propTypes = {
  contactLead: PropTypes.object,
  contactFields: PropTypes.any,
  contactSchema: PropTypes.object,
  useAppointmentFlow: PropTypes.bool,
  guideType: PropTypes.string,
  guideDelivery: PropTypes.string
};

export default ContactMe;

